import { render } from "./InscriptionTbody.vue?vue&type=template&id=2476ed32&scoped=true"
import script from "./InscriptionTbody.vue?vue&type=script&lang=js"
export * from "./InscriptionTbody.vue?vue&type=script&lang=js"

import "./InscriptionTbody.vue?vue&type=style&index=0&id=2476ed32&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2476ed32"]])

export default __exports__